//React Imports
import { useState, forwardRef, createRef, useEffect } from "react";
import { useFormContext } from "react-hook-form";

// MUI Imports
import {
  InputAdornment,
  IconButton,
  ThemeProvider,
  Stack,
} from "@mui/material";
import { DateRangeSharp } from "@mui/icons-material";

// Other Libraries
import format from "date-fns/format";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// Project Imports
import { formatToShowDateTime } from "src/qubCommon/helperMethods/dateHelper";
import { CssTextField } from "./CssTextField";
import { parse } from "date-fns";
import RowLabel from "./RowLabel";
import ColumnLabel from "./ColumnLabel";
import "./DateInputs.css";
import { registerLocale } from "react-datepicker";
import el from "date-fns/locale/el";

registerLocale("el", el);

const dateFormat = { format: 'dd/MM/yyyy', d: 0, m: 1, y: 2 }

const DateTimeInput = (props) => {
  const dateTimeFormat = dateFormat?.format + " HH:mm";
  const { setValue, getValues, formState } = useFormContext();
  const { fieldsVariant } = useSelector((state) => state.customization);

  const {
    defaultDate = "",
    defaultTime = "",
    locked = false,
    label = "",
    cmpyrsValidation = false,
    variant = fieldsVariant ?? "standard",
    name,
    labelWidth = 120,
    rowDirection = false,
    isFullWidth = false,
    sx,
    defaultFromProps = true,
    blurFn,
    ...other
  } = props;

  const [input, setInput] = useState(
    defaultDate
      ? format(new Date(defaultDate + " " + defaultTime), dateTimeFormat)
      : ""
  );
  const [datePickerValue, setDatePickerValue] = useState(
    defaultDate
      ? format(new Date(defaultDate), dateTimeFormat)
      : null
  );
  const dateRef = createRef();
  const { errors } = formState;

  const CustomDatePicker = forwardRef(({ value, onClick }, ref) => (
    <IconButton onClick={onClick} ref={ref}>
      <DateRangeSharp />
    </IconButton>
  ));

  useEffect(() => {
    if (defaultDate && defaultTime && defaultFromProps)
      setValue(name, defaultDate + " " + defaultTime);
    else if (!defaultFromProps && getValues(name) !== "" && getValues(name) !== undefined && getValues(name)) {
      console.log(getValues(name))
      setInput(format(new Date(getValues(name)), dateTimeFormat));
      setDatePickerValue(format(new Date(getValues(name)), dateTimeFormat));
    }
  }, []);

  const handleDatePickerChange = (e) => {
    console.log(e, format(e, dateTimeFormat), '1')
    setInput(format(e, dateTimeFormat));
    console.log(e, format(e, dateTimeFormat), '2')
    setValue(name, format(e, dateTimeFormat));
    console.log(e, format(e, dateTimeFormat), '3')
    setDatePickerValue(format(e, dateTimeFormat));
    console.log(e, format(e, dateTimeFormat), '4')
    if (blurFn)
      blurFn(format(format(e, dateTimeFormat), dateTimeFormat), {
        shouldDirty: true,
      });
  };

  console.log(datePickerValue, 'Mello')

  return (
    <Stack direction={rowDirection ? "row" : "column"} spacing={1}>
      {variant === "standard" && (
        <>
          {rowDirection ? ( // variant = 'standard'
            <RowLabel labelWidth={labelWidth} label={label} />
          ) : (
            <ColumnLabel label={label} />
          )}
        </>
      )}
      <CssTextField
        fullWidth={isFullWidth}
        disabled={locked}
        variant={variant}
        fixedPadding={8}
        fixedPaddingLeft={12}
        error={!!errors[name]}

        helperText={errors[name]?.message}
        size="small"
        onBlur={() => {
          if (input === "") {
            setValue(name, "")
            return;
          }
          let dateTimePicked = formatToShowDateTime(
            input,
            dateFormat,
            dateTimeFormat,
            defaultDate,
            defaultTime
          );

          setInput(dateTimePicked ?? "");
          setValue(
            name,
            format(
              parse(dateTimePicked, dateFormat.format + " HH:mm", new Date()),
              "yyyy-MM-dd HH:mm"
            )
          );
          setDatePickerValue(
            format(
              parse(dateTimePicked, dateTimeFormat, new Date()),
              dateTimeFormat
            ) ?? format(new Date(), dateTimeFormat)
          );
        }}
        value={input}
        onChange={(e) => setInput(e?.target?.value)}
        InputProps={
          locked
            ? { disableUnderline: true }
            : {
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position="end">
                  <DatePicker
                    locale='el'
                    showTimeSelect
                    timeFormat="HH:mm"
                    selected={datePickerValue ? parse(
                      datePickerValue,
                      dateTimeFormat,
                      new Date()
                    ) : null}
                    onChange={handleDatePickerChange}
                    calendarClassName="custom-datepicker"
                    customInput={<CustomDatePicker ref={dateRef} />}
                    showYearDropdown
                    popperProps={{
                      strategy: "fixed", // use this to make the popper position: fixed
                    }}
                  />
                </InputAdornment>
              ),
            }
        }
        sx={{ zIndex: 1052, ...sx }}
        {...other}
      />
    </Stack>
  );
};

export default DateTimeInput;
